import { Link } from 'react-router-dom';
import { WHATSAPP_CHAT_URL } from '../../../config/contactLinks';

const services = [
  { icon: 'ri-building-4-line', title: 'İnşaat Sonrası Temizlik', desc: 'Toz, çimento ve kir kalıntılarının derin temizliği. Anahtar teslim hazır.' },
  { icon: 'ri-home-4-line', title: 'Daire & Ofis Temizliği', desc: 'Günlük, haftalık veya aylık periyodik temizlik paketleri.' },
  { icon: 'ri-hotel-line', title: 'Villa Temizliği', desc: 'Geniş alanlara özel detaylı temizlik. Her köşe, her yüzey.' },
  { icon: 'ri-key-line', title: 'Kiracı Sonrası Temizlik', desc: 'Çıkış temizliği ile mülkünüzü hızla yeni kiracıya hazırlıyoruz.' },
  { icon: 'ri-store-3-line', title: 'Kurumsal Mağaza Temizliği', desc: 'İşyeri ve mağazalar için özel temizlik çözümleri.' },
  { icon: 'ri-restaurant-line', title: 'Kafe & Restaurant', desc: 'Gıda hijyen standartlarına uygun mutfak ve salon temizliği.' },
  { icon: 'ri-building-line', title: 'Dış Cephe Temizliği', desc: 'Yüksek basınçlı ekipmanlarla bina dış cephe yıkama.' },
  { icon: 'ri-plant-line', title: 'Bahçe Temizliği', desc: 'Yaprak toplama, genel temizlik ve düzenleme hizmetleri.' },
  { icon: 'ri-community-line', title: 'Apartman Temizliği', desc: 'Merdiven, giriş ve ortak alan temizliği. Aylık kontrat.' },
  { icon: 'ri-window-line', title: 'Cam Temizliği', desc: 'İç ve dış cam yüzeyler için kristal netliğinde temizlik.' },
  { icon: 'ri-sofa-line', title: 'Koltuk & Halı Yıkama', desc: 'Buharlı derin yıkama ile hijyenik ve ferah dokumalar.' },
];

export default function Services() {
  return (
    <section id="hizmetler" className="py-24 relative overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #f2f4fb 0%, #ffffff 100%)' }}>

      {/* Large ghost number decoration */}
      <div className="absolute -top-4 right-8 text-[220px] font-extrabold text-navy/[0.03] leading-none select-none pointer-events-none hidden lg:block">
        11
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-8">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-6">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-[2px] bg-gold rounded-full" />
              <p className="text-gold text-[11px] font-bold uppercase tracking-[0.25em]">Hizmet Portföyümüz</p>
            </div>
            <h2 className="text-4xl md:text-5xl font-extrabold text-navy tracking-tight leading-tight">
              11 Farklı<br />Temizlik Hizmeti
            </h2>
          </div>
          <div className="md:text-right max-w-xs">
            <p className="text-gray-400 text-sm leading-relaxed">
              Konuttan ticari alana, inşaattan bahçeye kadar Niğde&apos;nin en kapsamlı temizlik portföyü.
            </p>
            <a href={WHATSAPP_CHAT_URL} target="_blank" rel="nofollow noreferrer"
              className="inline-flex items-center gap-2 mt-4 bg-gold/10 text-gold hover:bg-gold hover:text-white px-4 py-2 rounded-lg text-[11px] font-bold uppercase tracking-wider transition-all cursor-pointer whitespace-nowrap">
              <i className="ri-whatsapp-line"></i> Teklif Al
            </a>
          </div>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {services.map((svc, idx) => (
            <Link
              key={svc.title}
              to="/iletisim"
              className="group relative bg-white border border-gray-100 rounded-xl p-6 hover:border-transparent transition-all duration-300 cursor-pointer overflow-hidden block"
              style={{ boxShadow: '0 1px 3px rgba(26,43,94,0.06)' }}
              onMouseEnter={e => { (e.currentTarget as HTMLElement).style.boxShadow = '0 8px 30px rgba(201,168,76,0.18)'; }}
              onMouseLeave={e => { (e.currentTarget as HTMLElement).style.boxShadow = '0 1px 3px rgba(26,43,94,0.06)'; }}
            >
              {/* Top gold accent bar */}
              <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-transparent via-gold to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

              {/* Number badge */}
              <span className="absolute top-4 right-4 text-[11px] font-extrabold text-navy/15 group-hover:text-gold/60 transition-colors tracking-wider">
                {String(idx + 1).padStart(2, '0')}
              </span>

              <div className="w-11 h-11 flex items-center justify-center bg-navy-light rounded-xl mb-4 group-hover:bg-gold group-hover:scale-110 transition-all duration-300">
                <i className={`${svc.icon} text-navy group-hover:text-white text-xl transition-colors`}></i>
              </div>
              <h3 className="font-bold text-navy text-sm mb-2 leading-snug pr-6">{svc.title}</h3>
              <p className="text-gray-400 text-xs leading-relaxed">{svc.desc}</p>
              <div className="mt-5 flex items-center gap-1.5 text-[11px] font-bold text-gray-300 group-hover:text-gold transition-colors uppercase tracking-wider">
                <span>Teklif Al</span>
                <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform">
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}

          {/* CTA Card */}
          <div className="relative bg-navy rounded-xl p-6 flex flex-col justify-between cursor-pointer overflow-hidden group">
            <div className="absolute inset-0 bg-gradient-to-br from-navy via-navy to-navy-dark opacity-100 group-hover:opacity-80 transition-opacity" />
            <div className="absolute -bottom-8 -right-8 w-32 h-32 bg-gold/10 rounded-full" />
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-white/5 rounded-full" />
            <div className="relative z-10">
              <div className="w-11 h-11 flex items-center justify-center bg-gold/20 rounded-xl mb-4">
                <i className="ri-customer-service-2-line text-gold text-xl"></i>
              </div>
              <p className="text-white font-extrabold text-base mb-2">Ücretsiz Keşif</p>
              <p className="text-white/50 text-xs leading-relaxed">
                Hangi hizmet size uygun? Bize danışın, size özel çözüm üretelim.
              </p>
            </div>
            <a href={WHATSAPP_CHAT_URL} target="_blank" rel="nofollow noreferrer"
              className="relative z-10 mt-8 flex items-center gap-2 bg-gold hover:bg-gold-dark text-white px-4 py-2.5 rounded-lg text-xs font-bold whitespace-nowrap transition-colors w-fit">
              <i className="ri-whatsapp-line text-sm"></i> WhatsApp&apos;tan Yaz
            </a>
          </div>
        </div>

        {/* Bottom feature strip */}
        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { icon: 'ri-shield-check-line', text: 'Sigortalı Ekip' },
            { icon: 'ri-leaf-line', text: 'Çevre Dostu Ürünler' },
            { icon: 'ri-time-line', text: 'Zamanında Hizmet' },
            { icon: 'ri-tools-line', text: 'Profesyonel Ekipman' },
          ].map(f => (
            <div key={f.text} className="flex items-center gap-3 bg-white border border-gray-100 rounded-xl px-4 py-3.5">
              <span className="w-8 h-8 flex items-center justify-center bg-gold/10 rounded-lg shrink-0">
                <i className={`${f.icon} text-gold text-base`}></i>
              </span>
              <span className="text-navy font-bold text-xs">{f.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
